/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StationOrLocationItem,
    StationOrLocationItemFromJSON,
    StationOrLocationItemFromJSONTyped,
    StationOrLocationItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface StationOrLocationItemAutocompleteResult
 */
export interface StationOrLocationItemAutocompleteResult {
    /**
     * 
     * @type {Array<StationOrLocationItem>}
     * @memberof StationOrLocationItemAutocompleteResult
     */
    results?: Array<StationOrLocationItem> | null;
    /**
     * 
     * @type {number}
     * @memberof StationOrLocationItemAutocompleteResult
     */
    numberOfItems?: number;
}

export function StationOrLocationItemAutocompleteResultFromJSON(json: any): StationOrLocationItemAutocompleteResult {
    return StationOrLocationItemAutocompleteResultFromJSONTyped(json, false);
}

export function StationOrLocationItemAutocompleteResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationOrLocationItemAutocompleteResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(StationOrLocationItemFromJSON)),
        'numberOfItems': !exists(json, 'numberOfItems') ? undefined : json['numberOfItems'],
    };
}

export function StationOrLocationItemAutocompleteResultToJSON(value?: StationOrLocationItemAutocompleteResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(StationOrLocationItemToJSON)),
        'numberOfItems': value.numberOfItems,
    };
}


